import { useHotkey } from '@app/core/hotkeys/useHotkey';
import { streamHotkeys } from '../../stream-hotkeys';
import { useShiftCursor } from '../cursor/useShiftCursor';
import {
  useSetSelectionEndFromTs,
  useSetSelectionStartFromTs,
} from '../selection/useSelectionActions';
import { useStreamGlobalPlayPause } from './useStreamPlayback';

/**
 * Stream hotkeys that require PlaybackProvider context.
 * These hotkeys handle play/pause, cursor movement (shift cursor), and selection from current playback timestamp.
 *
 * This hook must be used inside a PlaybackProvider.
 * Core hotkeys (focus, zoom, selection from cursor, etc.) are handled in useStreamHotkeysCore.
 */
export function useStreamPlaybackHotkeys() {
  const streamGlobalPlayPause = useStreamGlobalPlayPause();
  const shiftCursor = useShiftCursor();
  const setSelectionStartFromTs = useSetSelectionStartFromTs();
  const setSelectionEndFromTs = useSetSelectionEndFromTs();

  // Playback control
  useHotkey(streamHotkeys.playback.hotkeys.PLAY_PAUSE, () => {
    streamGlobalPlayPause();
  });

  // Selection from playback timestamp
  useHotkey(streamHotkeys.selection.hotkeys.START_PLAY_TS_SELECTION, () => {
    setSelectionStartFromTs();
  });

  useHotkey(streamHotkeys.selection.hotkeys.END_PLAY_TS_SELECTION, () => {
    setSelectionEndFromTs();
  });

  // Cursor movement (shift cursor)
  useHotkey(streamHotkeys.cursor.hotkeys.CURSOR_BACK_1S, () => {
    shiftCursor(-1000);
  });

  useHotkey(streamHotkeys.cursor.hotkeys.CURSOR_BACK_5S, () => {
    shiftCursor(-5000);
  });

  useHotkey(streamHotkeys.cursor.hotkeys.CURSOR_FORWARD_1S, () => {
    shiftCursor(1000);
  });

  useHotkey(streamHotkeys.cursor.hotkeys.CURSOR_FORWARD_5S, () => {
    shiftCursor(5000);
  });
}
